/**
 * Prefix an in-app path with `NEXT_PUBLIC_DISCOVERY_BASE_PATH` for raw `<a href>`,
 * `fetch` URLs, and `redirect()` from Route Handlers.
 *
 * Server Component `redirect()` and `next/link` already add `basePath`. Do not
 * use this with those APIs or the path will be prefixed twice. Route Handler
 * `redirect()` writes the Location header as given and does not add `basePath`.
 */
export function discoveryRoutePath(path: string): string {
	const basePath = (process.env.NEXT_PUBLIC_DISCOVERY_BASE_PATH ?? "").replace(
		/\/+$/,
		""
	);
	const normalized = path.startsWith("/") ? path : `/${path}`;
	if (!basePath) {
		return normalized;
	}
	if (normalized === "/") {
		return basePath;
	}
	return `${basePath}${normalized}`;
}
